export default __webpack_public_path__ + "img/benefits4.596c5fe1.svg";